module.exports = __webpack_public_path__ + "img/20-min.a4835259.jpg";